import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query FlowDownstreamWorkbooksFilteredByFlowOutputFieldWithoutPersonalSpaceQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: WorkbookSortOrder!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
          }
        }
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
